export default {
  apiUrl: 'https://v-forum-api.bahdcasts.com/api'
}


// WEBPACK FOOTER //
// ./src/config/index.js